/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M18.25 10a.75.75 0 0 0-1.5 0v2a.75.75 0 0 0 1.5 0v-2ZM4.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75ZM5 18.25a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5H5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.25 3c0-1.5188 1.2312-2.75 2.75-2.75h1c1.5188 0 2.75 1.2312 2.75 2.75v2H22c1.1046 0 2 .8954 2 2v5c0 2.116-1.0954 3.9762-2.75 5.0444V21.5c0 1.5188-1.2312 2.75-2.75 2.75H2.75C1.2312 24.25 0 23.0188 0 21.5v-10c0-1.5188 1.2312-2.75 2.75-2.75H11V7c0-1.1046.8954-2 2-2h1.25V3Zm5 0v2h-3.5V3c0-.6904.5597-1.25 1.25-1.25h1c.6904 0 1.25.5596 1.25 1.25ZM13 6.5h9a.5.5 0 0 1 .5.5v5c0 2.4853-2.0147 4.5-4.5 4.5h-1c-2.4853 0-4.5-2.0147-4.5-4.5V7a.5.5 0 0 1 .5-.5Zm-2 3.75H2.75c-.6904 0-1.25.5596-1.25 1.25v10c0 .6904.5596 1.25 1.25 1.25H18.5c.6904 0 1.25-.5596 1.25-1.25v-3.7592A6.001 6.001 0 0 1 18 18h-1c-3.3137 0-6-2.6863-6-6v-1.75Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Credentials'
);
